import React from 'react';
import { Link } from 'react-router-dom';

import Hamburger from './Hamburger';
import routes from '../../data/routes';

const ExternalArrow = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginLeft: '6px', verticalAlign: 'middle', opacity: 0.7 }}
  >
    <line x1="7" y1="17" x2="17" y2="7" />
    <polyline points="7 7 17 7 17 17" />
  </svg>
);

// Websites Navbar, displays routes defined in 'src/data/routes'
const Navigation = () => (
  <header id="header">
    <div className="index-link">
      {routes.filter((l) => l.index).map((l) => (
        <Link key={l.label} to={l.path}>{l.label}</Link>
      ))}
    </div>
    <nav className="links">
      <ul>
        {routes.filter((l) => !l.index).map((l) => (
          <li key={l.label}>
            {l.isExternal ? (
              <a
                href={l.path}
                target="_blank"
                rel="noopener noreferrer"
                className={l.highlight ? 'highlighted-link' : ''}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                {l.label}
                <ExternalArrow />
              </a>
            ) : (
              <Link
                to={l.path}
                className={l.highlight ? 'highlighted-link' : ''}
              >
                {l.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </nav>
    <Hamburger />
  </header>
);

export default Navigation;
